import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure76 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '600px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#ed7d31', '#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
		   'Composante agricole du stress hydrique (désagrégation de l’indicateur 6.4.2)',
		   'Proportion de la population rurale vivant en dessous du seuil international de pauvreté (désagrégation de l’indicateur 1.1.1)',
		   'Consommation de pesticides à l’hectare',
		   'Proportion de la surface exploitée en agriculture biologique',
		   'Production brute à l’hectare',
		   'Diversification de la production brute',
		   'Consommation d’engrais à l’hectare',
		   'Valeur ajoutée agricole par travailleur (lien avec l’indicateur 2.3.2)',
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        	format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 5,
      min: 0,
      tickInterval: 1,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: 'S’orienter',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
          4,
          4,
          3,
          4,
          4,
          3,
          4,
          4,
      ]
    },{
        name: 'Statut actuel',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
        4,
        4,
        3,
        3,
        2,
        4,
        3,
        3,
      ],
    }]
}
